import { useState } from "react";
import api, { errMsg } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";

export function SendPoEmailDialog({ po, supplierEmail, open, onOpenChange, onSent }) {
  const { t } = useI18n();
  const [to, setTo] = useState(supplierEmail || "");
  const [cc, setCc] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      const split = (s) => s.split(/[,;\s]+/).map((x) => x.trim()).filter(Boolean);
      const { data } = await api.post(`/purchase-orders/${po.id}/send-email`, { to: split(to), cc: split(cc), message });
      toast.success(`${t("po.emailSent")}: ${data.to.join(", ")}`);
      onOpenChange(false);
      onSent?.();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none sm:max-w-lg" data-testid="po-email-dialog">
        <DialogHeader>
          <DialogTitle className="uppercase font-black flex items-center gap-2"><Mail size={14} /> {t("po.sendEmail")} · {po.number}</DialogTitle>
          <DialogDescription className="text-xs">{t("po.sendEmailHint")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label className="text-[10px] font-bold uppercase tracking-widest">{t("po.emailTo")}</Label>
            <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="proveedor@empresa.com" className="rounded-none h-8 text-xs" data-testid="po-email-to" />
          </div>
          <div className="space-y-1">
            <Label className="text-[10px] font-bold uppercase tracking-widest">CC</Label>
            <Input value={cc} onChange={(e) => setCc(e.target.value)} placeholder="compras@…, almacen@…" className="rounded-none h-8 text-xs" data-testid="po-email-cc" />
          </div>
          <div className="space-y-1">
            <Label className="text-[10px] font-bold uppercase tracking-widest">{t("po.emailMessage")}</Label>
            <Textarea value={message} rows={3} onChange={(e) => setMessage(e.target.value)} className="rounded-none text-xs" data-testid="po-email-message" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={send} disabled={busy || !to.trim()} className="rounded-none text-xs font-bold" data-testid="po-email-send">
            <Send size={12} className="mr-1" /> {busy ? "…" : t("po.sendEmail")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
